module.exports = __webpack_public_path__ + "img/index.1bd38018.png";